class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const autoplayEnabled =
        this.getAttribute("data-autoplay-enabled") === "true";
      const autoplayDelay =
        parseInt(this.getAttribute("data-autoplay-delay"), 10) || 3000;

      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 50,
        loop: true,
        effect: "fade",
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      };

      if (autoplayEnabled) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        };
      }

      new Swiper(".swiper-announcementbar-slider", swiperOptions);
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("announcement-bar", AnnouncementBar);

class CustomProductItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      new Swiper(".collection-item-slider-" + this.getAttribute("data-pid"), {
        spaceBetween: 20,
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-product-item", CustomProductItem);


class CustomTabView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      jQuery(document).ready(function($) {
        $('.tab-title').eq(0).addClass('active-title');
        $('.tab-content').eq(0).addClass('active');
        $('.tab-title').click(function(){
        var title = $(this).attr('title');
        $('.tab-title').removeClass('active-title');
        $(this).addClass('active-title');
        $('.tab-content').removeClass('active');
        $('.tab-content[content="'+ title +'"]').addClass('active');
        });
    
         var $type = $(".product__block--product-header").data("tag");
            $(".match-top-heading").hide();
            $(".match-top-heading[id='" + $type + "']").show();
    
      });

    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-tab-view", CustomTabView);


class CustomImageSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var this2 = $(this);
      $(this2).css({ opacity: "1" });

      var autoplay = $(this).data("autoplay");

      if (autoplay == false) {
        var swiper = new Swiper(
          ".slide-image-" + this.getAttribute("data-sectionid"),
          {
            spaceBetween: 15,
            slidesPerView: 4.5,
            loop:true,
            breakpoints: {
              450: {
                slidesPerView: 4.5,
                spaceBetween: 15,
              },
              550: {
                slidesPerView: 4.5,
                spaceBetween: 15,
              },
              640: {
                slidesPerView: 4,
                spaceBetween: 15,
              },
              768: {
                slidesPerView: 6,
                spaceBetween: 25,
              },
              1024: {
                slidesPerView: 9,
                spaceBetween: 30,
              },
              1199: {
                slidesPerView: 8,
                spaceBetween: 30,
                loop: true,
              },
              1441: {
                slidesPerView: 9,
                spaceBetween: 35,
              },
            },
          }
        );
      } else {
        var swiper = new Swiper(
          ".slide-image-" + this.getAttribute("data-sectionid"),
          {
            autoplay: {
              delay: 0,
              disableOnInteraction: false,
            },
            effect: "linear",
            spaceBetween: 6,
            slidesPerView: 4.5,
            loop: true,
            speed: 3000,
            breakpoints: {
              450: {
                slidesPerView: 4.5,
                spaceBetween: 6,
              },
              550: {
                slidesPerView: 4.5,
                spaceBetween: 6,
              },
              640: {
                slidesPerView: 7.5,
                spaceBetween: 6,
              },
              768: {
                slidesPerView: 8.5,
                spaceBetween: 28,
                loop: true,
              },
              1024: {
                slidesPerView: 9.5,
                spaceBetween: 28,
                loop: true,
              },
              1441: {
                slidesPerView: 10.5,
                spaceBetween: 28,
                loop: true,
              },
              1600: {
                slidesPerView: 14.5,
                spaceBetween: 28,
                loop: true,
              }
            },
          }
        );
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-image-slider", CustomImageSlider);

class CustomAnnouncementBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var anntype = $(this).data("anntype");

      if (anntype == "scrolling") {
        var swiper = new Swiper(".announcemment-bar-slider", {
          slidesPerView: "auto",
          spaceBetween: 30,
          allowTouchMove: false,
          freeModeMomentum: false,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          effect: "linear",
          loop: true,
          speed: 5000,
          freeMode: true,
          breakpoints: {
            640: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            660: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            769: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            945: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            1300: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            1441: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
          },
        });

        var swiper = new Swiper(".announcemment-bar-slidermob", {
          spaceBetween: 30,
          slidesPerView: "auto",
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          freeModeMomentum: false,
          freeMode: true,
          effect: "linear",
          loop: true,
          speed: 5000,
          allowTouchMove: false,
          breakpoints: {
            640: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            660: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            769: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            945: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
            1440: {
              slidesPerView: "auto",
              spaceBetween: 30,
            },
          },
        });
      } else {
        var swiper = new Swiper(".announcemment-bar-slider", {
          slidesPerView: 1,
          spaceBetween: 10,
          freeModeMomentum: false,
          freeMode: true,
          breakpoints: {
            500: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            600: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 10,
            },
            945: {
              slidesPerView: 3.5,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          },
        });

        var swiper = new Swiper(".announcemment-bar-slidermob", {
          spaceBetween: 10,
          slidesPerView: 2,
          freeModeMomentum: false,
          freeMode: true,
          breakpoints: {
            500: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            600: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 10,
            },
            945: {
              slidesPerView: 3.5,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          },
        });
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}
customElements.define("custom-announcement-bar", CustomAnnouncementBar);

class bannerslider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);
      $(this).css({ opacity: "1" });

      new Swiper(".banner-slider--" + this.getAttribute("data-sectionid"), {
        pagination: {
          el: ".swiper-pagination",
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("banner-slider", bannerslider);

class BestSellerProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

     $('input[type="submit"]').on('click', function(event) {
        var this2 = $(this);
        var id = $(this).attr("data-value");
       
        var producttitle = $(this).data('producttitle');
        var productid = $(this).data('productid');
        var productprice = $(this).data('productprice');
        var productcurrency = $(this).data('currency');
       
        $.ajax({
          url: "/cart/add.js",
          type: "POST",
          dataType: "json",
          data: {
            id: id,
            quantity: 1,
          },
          success: function (data) {
            window.location.href= "/cart";
          },
        });

       window.__ii.send({
          eventName: 'PixelView',
          eventData: {
            product_id: productid,
            product_name: producttitle,
            price: parseFloat(productprice),
            currency: productcurrency 
          }
        });
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("best-seller-products", BestSellerProducts);

 class CustomHighlight extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var blocksize = $(this).data('blocksize');
      var sectionid = this.getAttribute("data-sectionid");
      var swiper = new Swiper(
        ".highlight-swiper-slider-" + sectionid,
        {
          slidesPerView: 3,
          spaceBetween: 10,
          breakpoints: {
            0: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            769:{
              slidesPerView: 5,
              spaceBetween: 40,
            },
            1024:{
              slidesPerView: 6,
              spaceBetween: 73,
            }
          },
        }
      );
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("custom-highlighted", CustomHighlight);

class CustomViewRoom extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
  
      $(this).css({"opacity": "1"});
      var slidetime = $(this).data('slide-time');
       var sectionid = this.getAttribute("data-sectionid");
  
      var swiperview = new Swiper(".main-lifestyle-wrapper-" + sectionid, {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        effect: "fade",
      });
  
      var swiperviewcard = new Swiper(".view-card-slider-" + sectionid, {
        loop: true,
        spaceBetween: 10,
        autoplay: {
          delay: slidetime,
          disableOnInteraction: false,
        },
      });
      swiperview.controller.control = swiperviewcard;
      swiperviewcard.controller.control = swiperview;

      $('.main-content-button').unbind().click(function(){
        $('.view-card-slider').find('.swiper-slide-active .card-image-button').click();
      });
  
    };
  
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
  
    observer.observe(this);
  }
 }

customElements.define("custom-view-room", CustomViewRoom);

class CustomMainProductDefault extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
 
    jQuery(document).ready(function($) {
       let modal_size = document.querySelector('#modal-size-guide');
       let btn_size = document.querySelector('#button-size');
       let close_btn_size = document.querySelector('#modal-close-size');

       btn_size.addEventListener('click',display);

       function display(){
           modal_size.style.display = 'block';
       }
      close_btn_size.addEventListener('click',hide);
      window.addEventListener('click',(event)=>{
          if(event.target == modal_size){
              modal_size.style.display = 'none';
          }
      });
      function hide(){
          modal_size.style.display = 'none';
      }


    $(document).on('click', '.custom_need_help-2', function(){
      console.log('test')
      if(document.getElementById("dummy-chat-button-iframe")){
        document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle').click();
      }else{
         document.getElementById('ShopifyChat').contentDocument.querySelector('.chat-toggle').click();
      }
    });

     $( document ).ready(function() {
        if($('.modal-custom-form').length > 0){
          var modal = document.querySelector(".modal-custom-form");
          var trigger = document.querySelector(".custom_need_help-1");
          var closeButton = document.querySelector(".close-button");
    
          function toggleModal() {
              modal.classList.toggle("show-modal");
          }
    
          function windowOnClick(event) {
              if (event.target === modal) {
                  toggleModal();
              }
          }
    
          trigger.addEventListener("click", toggleModal);
          closeButton.addEventListener("click", toggleModal);
          window.addEventListener("click", windowOnClick);
       }
     });
    });

     $(document).ready(function() {
      $(".product__media-show-more .btn--tertiary").click(function() {
        $(this).parents().find('.product__media-item--hide-on-load').toggleClass("product__media-item--show");
      
        if ($(this).parents().find('.product__media-item--hide-on-load').hasClass('product__media-item--show')) {
            $(this).text('Less Media');
        } else {
            $(this).text('More Media');
      }
      });

     var thumbswiper = new Swiper(".thumb_swiper", {
        slidesPerView: 4.8,
        freeMode: true,
        mousewheel: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
      });
      
      var main_swiper = new Swiper(".main_swiper", {
        thumbs: {
            swiper: thumbswiper,
        },
        on: {
          slideChangeTransitionEnd: function () {
            manageVideoPlayback();
          }
        },
      });

      function manageVideoPlayback() {
        $('.main_swiper .swiper-slide video').each(function () {
          this.pause();
          this.currentTime = 0;
          $('.plyr__control').css({"opacity":"1", "visibility":"visible"});
        });
      
        var activeSlide = $('.swiper-slide-active');
        var video = activeSlide.find('video');
        if (video.length) {
          video[0].play();
          $('.plyr__control').css({"opacity":"0", "visibility":"hidden"});
        }else{
          $('.plyr__control').css({"opacity":"1", "visibility":"visible"});
        }
      }

      document.addEventListener("repositionmainslidermob", (e) => {
        var index = e.detail.index;
        main_swiper.slideTo(index);
        thumbswiper.slideTo(index);
      });

      $(document).ready(function() {
        $('.main_swiper .product__media-item-video').unbind().click(function() {
          var video = $(this).find('video').get(0);
          if (video) {
              if (video.paused) {
                  console.log("play");
                  video.play();
                  $('.plyr__control').css({"opacity":"0", "visibility":"hidden"});
              } else {
                  console.log("pause");
                  video.pause();
                  $('.plyr__control').css({"opacity":"1", "visibility":"visible"});
              }
          }
         });
      });

      if($('.product__color-swatch').length > 0){
        var imageindex = $('.product__color-swatch.selected').data('media-position');
        var indexposition = imageindex - 1;
        
        const startEvent = new CustomEvent("repositionmainslider", {
          detail: { index: indexposition },
        });
  
        const startEventMob = new CustomEvent("repositionmainslidermob", {
          detail: { index: indexposition },
        });
        
        document.dispatchEvent(startEvent);
        document.dispatchEvent(startEventMob);
      }
       
     });
    };
  
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
  
    observer.observe(this);
  }
 }

customElements.define("custom-main-product-default", CustomMainProductDefault);


// class CustomSlider extends HTMLElement {
//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);

//       $(this).css({ opacity: "1" });

//       var galleryThumbs = new Swiper(".thumb-slider", {
//         spaceBetween: 15,
//         direction: "horizontal",
//         slidesPerView: 4,
//         mousewheel: true,
//         navigation: {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev",
//         },
//         breakpoints: {
//           0: {
//             slidesPerView: 4,
//             spaceBetween: 15,
//             direction: "horizontal",
//           },
//           768: {
//             slidesPerView: 4,
//             spaceBetween: 15,
//             direction: "horizontal",
//           },
//           1024: {
//             slidesPerView: 5,
//             spaceBetween: 12,
//             direction: "vertical",
//           },
//           1441: {
//             slidesPerView: 6,
//             spaceBetween: 12,
//             direction: "vertical",
//           },
//         },
//         navigation: {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev",
//         }, 
//       });

//       var galleryTop = new Swiper(".main-slider", {
//         spaceBetween: 15,
//         direction: "horizontal",
//         thumbs: {
//           swiper: galleryThumbs,
//         },
//         breakpoints: {
//           0: {
//             slidesPerView: 1,
//             spaceBetween: 15,
//             direction: "horizontal",
//           },
//           768: {
//             slidesPerView: 1,
//             spaceBetween: 15,
//             direction: "horizontal",
//           },
//         },
//       });

//       document.addEventListener("repositionmainslider", (e) => {
//         var index = e.detail.index;
//         galleryTop.slideTo(index);
//         galleryThumbs.slideTo(index);
//       });
//     };

//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }

// customElements.define("custom-slider", CustomSlider);


class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      $(this).css({
        opacity: "1"
      });

      const thumbSlider = this.querySelector(".thumb-slider");
      const mainSlider = this.querySelector(".main-slider");

      if (!mainSlider) return;

      var galleryThumbs = null;

      if (thumbSlider) {
        galleryThumbs = new Swiper(thumbSlider, {
          spaceBetween: 15,
          direction: "horizontal",
          slidesPerView: 4,
          mousewheel: true,

          navigation: {
            nextEl: thumbSlider.querySelector(".swiper-button-next"),
            prevEl: thumbSlider.querySelector(".swiper-button-prev"),
          },

          breakpoints: {
            0: {
              slidesPerView: 4,
              spaceBetween: 15,
              direction: "horizontal",
            },

            991: {
              slidesPerView: 4,
              spaceBetween: 15,
              direction: "horizontal",
            },

            1024: {
              slidesPerView: 5,
              spaceBetween: 12,
              direction: "vertical",
            },

            1441: {
              slidesPerView: 6,
              spaceBetween: 12,
              direction: "vertical",
            },
          },
        });
      }

      const sendVimeoCommand = (iframe, method, value) => {
        if (!iframe || !iframe.contentWindow) return;

        try {
          const message = {
            method: method
          };

          if (typeof value !== "undefined") {
            message.value = value;
          }

          iframe.contentWindow.postMessage(
            JSON.stringify(message),
            "*"
          );
        } catch (error) {}
      };

      const resetHtmlVideo = (video) => {
        if (!video) return;

        try {
          video.pause();
          video.currentTime = 0;
        } catch (error) {}
      };

      const playHtmlVideo = (video, reset = true) => {
        if (!video) return;

        try {
          video.pause();

          if (reset) {
            video.currentTime = 0;
          }

          video.muted = false;
          video.defaultMuted = false;
          video.volume = 1;
          video.playsInline = true;

          const playPromise = video.play();

          if (
            playPromise &&
            typeof playPromise.catch === "function"
          ) {
            playPromise.catch(function () {
              video.muted = true;

              const mutedPlayPromise = video.play();

              if (
                mutedPlayPromise &&
                typeof mutedPlayPromise.catch === "function"
              ) {
                mutedPlayPromise.catch(function () {});
              }
            });
          }
        } catch (error) {}
      };

      const resetVimeoVideo = (iframe) => {
        if (!iframe) return;

        sendVimeoCommand(iframe, "pause");
        sendVimeoCommand(iframe, "setCurrentTime", 0);
      };

      const playVimeoVideo = (iframe, reset = true) => {
        if (!iframe) return;

        sendVimeoCommand(iframe, "pause");

        if (reset) {
          sendVimeoCommand(iframe, "setCurrentTime", 0);
        }

        setTimeout(() => {
          sendVimeoCommand(iframe, "setVolume", 1);
          sendVimeoCommand(iframe, "play");
        }, 150);
      };

      const stopAllVideos = () => {
        mainSlider
          .querySelectorAll("video")
          .forEach((video) => {
            resetHtmlVideo(video);
          });

        mainSlider
          .querySelectorAll(
            'iframe[src*="player.vimeo.com"]'
          )
          .forEach((iframe) => {
            resetVimeoVideo(iframe);
          });
      };

      const playActiveSlideVideo = (swiper) => {
        if (!swiper) return;

        const activeSlide =
          swiper.slides[swiper.activeIndex];

        if (!activeSlide) return;

        const htmlVideo =
          activeSlide.querySelector("video");

        if (htmlVideo) {
          playHtmlVideo(htmlVideo, true);
          return;
        }

        const vimeoIframe =
          activeSlide.querySelector(
            'iframe[src*="player.vimeo.com"]'
          );

        if (vimeoIframe) {
          playVimeoVideo(vimeoIframe, true);
        }
      };

      var galleryTop = new Swiper(mainSlider, {
        spaceBetween: 15,
        direction: "horizontal",

        thumbs: galleryThumbs
          ? {
              swiper: galleryThumbs
            }
          : undefined,

        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },

          991: {
            slidesPerView: 1,
            spaceBetween: 15,
            direction: "horizontal",
          },
        },

        on: {
          init: function () {
            const swiper = this;

            setTimeout(() => {
              stopAllVideos();
              playActiveSlideVideo(swiper);
            }, 300);
          },

          slideChangeTransitionStart: function () {
            stopAllVideos();
          },

          slideChangeTransitionEnd: function () {
            playActiveSlideVideo(this);
          },
        },
      });

      let pausedLightboxVideo = null;
      let pausedLightboxVimeo = null;
      let pausedHtmlTime = 0;

      const pauseCurrentSliderVideo = () => {
        const activeSlide =
          galleryTop.slides[galleryTop.activeIndex];

        if (!activeSlide) return;

        pausedLightboxVideo = null;
        pausedLightboxVimeo = null;
        pausedHtmlTime = 0;

        const htmlVideo =
          activeSlide.querySelector("video");

        if (htmlVideo) {
          pausedLightboxVideo = htmlVideo;

          try {
            pausedHtmlTime = htmlVideo.currentTime;
            htmlVideo.pause();
          } catch (error) {}

          return;
        }

        const vimeoIframe =
          activeSlide.querySelector(
            'iframe[src*="player.vimeo.com"]'
          );

        if (vimeoIframe) {
          pausedLightboxVimeo = vimeoIframe;

          sendVimeoCommand(
            vimeoIframe,
            "pause"
          );
        }
      };

      const resumeCurrentSliderVideo = () => {
        const activeSlide =
          galleryTop.slides[galleryTop.activeIndex];

        if (!activeSlide) return;

        if (
          pausedLightboxVideo &&
          activeSlide.contains(pausedLightboxVideo)
        ) {
          try {
            pausedLightboxVideo.currentTime =
              pausedHtmlTime;

            playHtmlVideo(
              pausedLightboxVideo,
              false
            );
          } catch (error) {}
        }

        if (
          pausedLightboxVimeo &&
          activeSlide.contains(pausedLightboxVimeo)
        ) {
          playVimeoVideo(
            pausedLightboxVimeo,
            false
          );
        }

        pausedLightboxVideo = null;
        pausedLightboxVimeo = null;
        pausedHtmlTime = 0;
      };

      mainSlider.addEventListener(
        "click",
        function (event) {
          const lightboxTrigger =
            event.target.closest(".lightbox-video");

          if (!lightboxTrigger) return;

          pauseCurrentSliderVideo();
        }
      );

      document.addEventListener(
        "product-lightbox-close",
        function () {
          setTimeout(() => {
            resumeCurrentSliderVideo();
          }, 100);
        }
      );

      const repositionHandler = (e) => {
        if (
          !e.detail ||
          typeof e.detail.index === "undefined"
        ) {
          return;
        }

        var index = e.detail.index;

        stopAllVideos();

        galleryTop.slideTo(index);

        if (galleryThumbs) {
          galleryThumbs.slideTo(index);
        }
      };

      document.addEventListener(
        "repositionmainslider",
        repositionHandler
      );
    };

    new IntersectionObserver(
      handleIntersection.bind(this),
      {
        rootMargin: "0px 0px 400px 0px"
      }
    ).observe(this);
  }
}

if (!customElements.get("custom-slider")) {
  customElements.define(
    "custom-slider",
    CustomSlider
  );
}

$(document).on('click', '.tab-view-chat-container-inbox', function(){
  console.log('Opening Shopify Chat');
  const chatContainer = document.getElementById('ShopifyChat');
  
  if (chatContainer?.shadowRoot) {
    const chatToggle = chatContainer.shadowRoot.querySelector('.chat-toggle');
    if (chatToggle) {
      chatToggle.click();
    } else {
      console.warn('chat-toggle button not found inside shadowRoot');
    }
  } else {
    console.error('ShopifyChat shadowRoot not available');
  }
});




